export const locale = {
  show: 'Show',
  hide: 'Hide',
};
